/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useLayoutEffect, useRef, memo, Fragment } from 'react';
import { Menu, Transition, Switch } from '@headlessui/react';
import { Link, useParams, useLocation } from 'react-router-dom';
import PlaylistModal from '../../../components/misc/PlaylistModal';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import Share from '../../../components/global/share';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import PlayVideo from './components/playVideo';
import PlayStream from './components/playStream';
import SliderAside from '../../../components/global/slider_aside';
import SEO from '../../../components/misc/SEO';
import {
  UsersIcon,
  SquaresPlusIcon,
  ClockIcon,
  HandThumbUpIcon as ThumbsUpFalse,
  ShareIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  HeartIcon as HeartIconAlt
} from '@heroicons/react/24/outline';
import {
  HandThumbUpIcon as ThumbsUpTrue,
  CheckBadgeIcon,
  PauseIcon,
  PlayIcon,
  HeartIcon
} from '@heroicons/react/24/solid';
import { truncate, duration, timeSince, abbreviateViews } from '../../../assets/scripts/script';
import Loading from '../../../components/misc/Loading';
import {
  useToken,
  useSidebarUpdate,
  useTheatre,
  useTheatreUpdate
} from '../../../components/misc/context';
import { capitalize } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDisplay, faTv } from '@fortawesome/free-solid-svg-icons';
import { useSidebar } from '../../../components/misc/context';
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Vidoes() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [upnext, setUpNext] = useState([]);
  const [video, setVideo] = useState('');
  const [defaultVideoURL, setDefaultVideoURL] = useState('');
  const [more, setMore] = useState(0);
  const [like, setLike] = useState(false);
  const [subscribe, setSubscribe] = useState(false);
  const [channelId, setChannelId] = useState('');
  const [totalLikes, setTotalLikes] = useState(0);
  const [open, setOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [videoTitle, setVideoTitle] = useState('');
  const [videoTranslationTitle, setVideoTranslationTitle] = useState('');
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [commentCounter, setCommentCounter] = useState(0);
  const [posting, setPosting] = useState(false);
  const [error, setError] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const token = useToken();
  const toggleRef = useRef(null);
  const toggleSidebar = useSidebarUpdate();
  const [pageTitle, setPageTitle] = useState('Watch');
  const [pageDescription, setPageDescription] = useState('');
  const [live, setLive] = useState(false);

  const [slugURL, setSlugURL] = useState('/');

  const theatre = useTheatre();
  const toggleTheatre = useTheatreUpdate();

  const params = useParams();

  const pathname = useLocation();
  const elements = pathname.pathname.split('/');

  const sidebar = useSidebar();

  const checkLanguage = (title, lan, arr) => {
    let x = arr.filter((item) => item.slug === lan)[0];

    if (x !== undefined && x.length !== 0) {
      updateLanguage(title, x.slug, x);
    }
  };

  useLayoutEffect(() => {
    try {
      setEnabled(JSON.parse(localStorage.getItem('ceflix.autoplay') || ''));
    } catch {
      localStorage.setItem('ceflix.autoplay', false);
      setEnabled(false);
    }
  }, []);

  async function countViewGuest() {
    const req = await fetch(`${process.env.REACT_APP_API_URL}video/offline-view-count`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`,
        'X-TOKEN': `${token.token}`
      },
      body: JSON.stringify({
        video: params.video_id,
        device: navigator.userAgent
      })
    });
    const res = await req.json();
  }

  const toggleAutoplay = () => {
    localStorage.setItem('ceflix.autoplay', !enabled);
    setEnabled(!enabled);
  };

  let user = '';
  try {
    user = JSON.parse(localStorage.getItem('ceflix.user') || '');
  } catch {
    user = '';
  }

  async function getVideo() {
    const req = await fetch(`${process.env.REACT_APP_API_URL}video`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`
            },
      body: JSON.stringify({ video: params.video_id })
    });
    const res = await req.json();

    const req2 = await fetch(`${process.env.REACT_APP_API_URL}video/comments`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`,
        'X-TOKEN': `${token}`
      },
      body: JSON.stringify({ video: params.video_id })
    });
    const res2 = await req2.json();

    if (!res.status) {
      setError(true);
    } else {
      setError(false);

      setVideo(res.data.video.url);
      setDefaultVideoURL(res.data.video.url);
      setData(res.data.video);
      setLive(res.data.video.url.split(".").pop() === 'm3u8' ? true : false);
      setCommentCounter(res.data.video.numOfComments);
      setUpNext(res.data.upnext);
      setTotalLikes(parseInt(res.data.video.likes));
      setLanguages(res.data.languages);
      setChannelId(res.data.video.channel_id);
      setVideoTitle(res.data.video.videos_title);
      setVideoTranslationTitle(res.data.video.videos_title);

      checkLanguage(res.data.video.videos_title, elements.pop(), res.data.languages);

      if (res2.status) {
        setComments(res2.data);
      }

      if(user !== ''){
        countView(data.videoID);
      } else {
        countViewGuest(data.videoID);
      }
      if (token !== '') {
        setLike(res.data.liked);
        setSubscribe(res.data.isSubscribed);
      }

      setPageTitle(res.data.video.videos_title);

      if (res.data.video.description !== null) {
        setPageDescription(res.data.video.description);
        if (res.data.video.description.length < 240) {
          setMore(0);
        } else {
          setMore(1);
        }
      }
    }
    setLoading(false);
  }

  const updateLanguage = (title, slug, data) => {
    navigate(`${title.replace(/[\s+-]/g, '-').toLowerCase()}/${slug}`);
    setSlugURL(slug);
    if (data.url.includes('.m3u8')) {
      setLive(true);
      setVideo(data.url);
      setVideoTranslationTitle(title + ' [' + slug + '] ');
    } else {
      setVideo(data.url);
      setLive(false);
      setVideoTranslationTitle(title + ' [' + slug + '] ');
    }
  };

  const defaultLanguage = () => {
    setVideo(defaultVideoURL);
    setVideoTranslationTitle(videoTitle);
    navigate(`${videoTitle.replace(/[\s+-]/g, '-').toLowerCase()}`);
    setSlugURL('/');
  };

  async function likeVideo() {
    if (!like) {
      setTotalLikes(totalLikes + 1);
    } else {
      setTotalLikes(totalLikes - 1);
    }

    setLike(!like);

    const req = await fetch(`${process.env.REACT_APP_API_URL}user/video/like`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`,
        'X-TOKEN': `${token}`
      },
      body: JSON.stringify({ token, video: params.video_id })
    });
    const res = await req.json();
  }

  async function channelSubscription() {
    const req = await fetch(`${process.env.REACT_APP_API_URL}channel/subscribe`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`
      },
      body: JSON.stringify({ channel: channelId, token })
    });
    const res = await req.json();
  }

  async function countView() {
    const req = await fetch(`${process.env.REACT_APP_API_URL}countvideoview`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`,
        'X-TOKEN': `${token}`
      },
      body: JSON.stringify({
        email: user.email,
        video: params.video_id,
        language: null
      })
    });
    const res = await req.json();
  }

  async function postComment(comment, fname, lname, profile_pic, com_time) {
    setPosting(true);
    const req = await fetch(`${process.env.REACT_APP_API_URL}video/comment/add`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Request-Method': 'POST',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`
      },
      body: JSON.stringify({ comment, video: params.video_id, token })
    });
    const res = await req.json();

    if (res.status) {
      setComments([{ comment, fname, lname, profile_pic, com_time: com_time / 1000 }, ...comments]);
      setComment('');
      setCommentCounter(commentCounter + 1);
    }

    setPosting(false);
  }

  useEffect(() => {
    if (window.innerWidth < 1024) {
      toggleTheatre(true);
    }
    getVideo();
  }, [params.video_id]);

  return (
    <>
      {!error ? (
        !loading ? (
          <>
          <SEO
          title={`${videoTranslationTitle} - Ceflix`}
          description={pageDescription}
          name={data.channel}
          type="article"
          image={data.thumbnail}
        />
          <div
            className={`text-white ${theatre ? 'lg:grid-cols-7 lg:gap-x-6 lg:pt-2 lg:px-4 2xl:px-[2rem] ceflix-watch' : ''} grid grid-cols-1  max-w-[110rem] mx-auto`}>
            {user !== '' && (
              <PlaylistModal open={open} setOpen={setOpen} videoId={data.id} token={token} />
            )}
            <div className={`block w-full ${theatre && 'lg:grid lg:rounded-md lg:col-span-5'} `}>
              <div className="lg:overflow-hidden">
                <div
                  className={`${!theatre && 'theatre-mode'} w-full aspect-video fixed z-[50] lg:z-auto lg:relative`}>
                  {live ? (
                    <PlayStream title={data.videos_title} poster={data.thumbnail} src={video} />
                  ) : (
                    <PlayVideo
                      title={data.videos_title}
                      poster={data.thumbnail}
                      video={video}
                      nextIsLive={upnext[0].isLive}
                      nextTitle={upnext[0].videos_title}
                      nextId={upnext[0].id}
                      nextDuration={upnext[0].duration}
                      nextChannelName={upnext[0].channel}
                      nextThumb={upnext[0].thumbnail}
                      autoplay={toggleRef}
                    />
                  )}
                </div>

                <div
                  className={`${!theatre && 'grid grid-cols-7 space-x-8 px-4'} pt-[58%] lg:pt-0`}>
                  <div className={!theatre && 'col-span-5'}>
                    <div className="flex flex-col pb-2 mt-4 lg:flex-row lg:mb-0 lg:space-x-4 items-start justify-between border-b-2 border-white/5">
                      <h1 className="flex-1 mx-4 lg:mx-2 text-lg sm:text-lg lg:text-xl font-bold tracking-tight">
                        {videoTranslationTitle}
                      </h1>
                      <div className="flex flex-row px-4 w-full lg:w-auto items-center md:justify-end">
                        <div className="flex flex-row w-full justify-between lg:justify-end font-medium text-xs items-center lg:mt-0 mt-4 pr-2">
                          <Share
                            open={shareOpen}
                            setOpen={setShareOpen}
                            title={data.videos_title}
                            url={window.location.href}
                            id={data.id}
                          />
                          <div className="flex flex-row items-center">
                            <button
                              type="button"
                              className="hidden lg:block mr-4 flex flex-row items-center transition hover:bg-neutral-800 rounded-md px-2 py-1.5"
                              onClick={() => toggleTheatre(!theatre)}>
                              <FontAwesomeIcon
                                icon={faTv}
                                className={`h-5 w-5 ${!theatre && 'text-red-700'}`}
                                aria-hidden="true"
                              />
                            </button>

                            <button
                              type="button"
                              className="flex mr-4 flex-row items-center transition hover:bg-neutral-800 rounded-md px-2 py-1.5"
                              onClick={() => {
                                if (user !== '') {
                                  likeVideo();
                                }
                              }}>
                              {like ? (
                                <HeartIcon
                                  className="h-5 w-5 mr-1 shrink-0 text-red-600"
                                  aria-hidden="true"
                                />
                              ) : (
                                <HeartIconAlt
                                  className="h-5 w-5 mr-1 shrink-0"
                                  aria-hidden="true"
                                />
                              )}
                              {totalLikes}
                            </button>

                            <button
                              type="button"
                              className="flex mr-4 flex-row items-center transition rounded-md hover:bg-neutral-800 py-1.5 px-2"
                              onClick={() => setOpen(true)}>
                              <SquaresPlusIcon
                                className="h-5 w-5 mr-1 shrink-0"
                                aria-hidden="true"
                              />{' '}
                              Playlist
                            </button>
                          </div>

                          {!live && (
                            <div className="flex flex-row justify-between items-center py-4 justify-end">
                              <Switch
                                ref={toggleRef}
                                checked={enabled}
                                onChange={() => toggleAutoplay()}
                                className={classNames(
                                  enabled ? 'bg-red-600' : 'bg-gray-200',
                                  'mr-2 relative inline-flex w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out'
                                )}>
                                <span className="sr-only">Use setting</span>
                                <span
                                  className={classNames(
                                    enabled ? 'translate-x-5' : 'translate-x-0',
                                    'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white ring-0 transition duration-200 ease-in-out'
                                  )}>
                                  <span
                                    className={classNames(
                                      enabled
                                        ? 'opacity-0 duration-100 ease-out'
                                        : 'opacity-100 duration-200 ease-in',
                                      'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                    )}
                                    aria-hidden="true">
                                    <PauseIcon
                                      className="h-4 w-4 text-red-600"
                                      aria-hidden="true"
                                    />
                                  </span>
                                  <span
                                    className={classNames(
                                      enabled
                                        ? 'opacity-100 duration-200 ease-in'
                                        : 'opacity-0 duration-100 ease-out',
                                      'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
                                    )}
                                    aria-hidden="true">
                                    <PlayIcon className="h-4 w-4 text-red-600" aria-hidden="true" />
                                  </span>
                                </span>
                              </Switch>
                              <p className="">Autoplay</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {languages.length >= 1 && (
                      <div className="mx-4 lg:mx-2 pt-2 mt-2 items-center bg-neutral-800 rounded-md p-2">
                        <>
                          <p className="text-xs mb-2 font-semibold">Available Languages</p>
                          <div className="space-x-2">
                            <button
                              type="button"
                              onClick={() => defaultLanguage()}
                              className="transition inline-block text-center rounded text-white bg-neutral-600 hover:bg-neutral-700 py-1 px-1.5 mb-2 text-xs">
                              Default
                            </button>
                            {languages.map((item) => (
                              <button
                                type="button"
                                key={item.id}
                                onClick={() => updateLanguage(videoTitle, item.slug, item)}
                                className={`${item.slug === slugURL ? 'bg-red-600 font-semibold' : 'bg-neutral-600 hover:bg-neutral-700'} transition inline-block text-center rounded text-white py-1 px-1.5 mb-2 text-xs`}>
                                {item.translation}
                              </button>
                            ))}
                          </div>
                        </>
                      </div>
                    )}

                    <div className="mx-4 lg:mx-2 pt-2 items-center">
                      <div className="flex flex-row my-1 items-center justify-between">
                        <div className="flex flex-row items-center">
                          <LazyLoadImage
                            alt="channel logo"
                            placeholderSrc="https://ceflix.org/images/avatar.png"
                            className="rounded-lg object-cover max-w-[3rem] w-12 h-12 mr-2"
                            src={data.channel_prefix + data.channel_file}
                          />
                          <div className="flex flex-col mr-4">
                            <Link
                              className="transition text-white hover:text-red-700"
                              to={`/channel/${data.channel_id}`}>
                              <h1 className="flex flex-row items-center font-semibold">
                                <span className="text-xs md:text-md">{data.channel}</span>
                                {data.isVerified === '1' && (
                                  <CheckBadgeIcon
                                    className="h-4 w-4 sm:h-5 sm:w-5 ml-1"
                                    aria-hidden="true"
                                  />
                                )}
                              </h1>
                            </Link>
                            {/* <h1 className="text-xs">{timeSince(data.uploadtime)}</h1> */}
                          </div>
                          <button
                            type="button"
                            className={`text-black transition font-bold rounded-full ${
                              !subscribe
                                ? 'bg-white hover:bg-white-10'
                                : 'text-white/80 bg-neutral-600 hover:bg-neutral-500'
                            } px-4 py-2 text-xs mr-2 lg:mr-0 lg:text-xs`}
                            onClick={() => {
                              channelSubscription();
                              setSubscribe(!subscribe);
                            }}>
                            {!subscribe ? 'Subscribe' : 'Unsubscribe'}
                          </button>
                        </div>

                        <button
                          type="button"
                          onClick={() => setShareOpen(true)}
                          className="flex flex-row text-black transition font-bold rounded-full bg-white hover:bg-white-10 lg:px-4 p-2 text-xs">
                          <ShareIcon className="h-4 w-4 lg:mr-1 shrink-0" aria-hidden="true" />
                          <p className="hidden lg:block font-bold">Share</p>
                        </button>
                      </div>
                    </div>
                    <div className="mx-4 lg:mx-2 relative my-4 bg-neutral-800 py-2 px-3 rounded-md">
                      <div>
                        <div className="flex flex-row gap-4 mb-1 text-xs font-semibold">
                          <span className="flex flex-row font-semibold items-center">
                            <UsersIcon className="pr-2 h-6 w-6 shrink-0" aria-hidden="true" />{' '}
                            {Intl.NumberFormat('en-US', {
                              notation: 'compact',
                              maximumFractionDigits: 1
                            }).format(data.numOfViews)}{' '}
                            views
                          </span>

                          <span className="flex flex-row font-semibold items-center">
                            <ClockIcon className="pr-2 h-6 w-6 shrink-0" aria-hidden="true" />{' '}
                            {timeSince(data.uploadtime)}
                          </span>
                        </div>
                        <p className={`${more === 1 && 'truncate'} text-sm`}>
                          {data.description}
                          {/* {truncate(data.description, 80)} */}
                        </p>

                        {more === 2 ||
                          (more === 0 && (
                            <div className="my-4">
                              {data.tags !== null &&
                                data.tags !== undefined &&
                                data.tags !== '' &&
                                data.tags.split(',').map((item) => (
                                  <Link
                                    className="transition inline-block text-center rounded text-white bg-neutral-600 hover:bg-neutral-700 py-1 px-1.5 mr-2 mb-2 text-xs"
                                    to={`/tag?name=${item.replace(/[_]/g, '-').toLowerCase()}`}
                                    key={item}>
                                    {item}
                                  </Link>
                                ))}
                            </div>
                          ))}
                      </div>
                      {more !== 0 &&
                        (more === 1 ? (
                          <button
                            type="button"
                            onClick={() => setMore(2)}
                            className="flex flex-row items-center text-red-600 text-xs mt-2 font-medium">
                            More{' '}
                            <ChevronDownIcon className="h-5 w-5 shrink-0 pl-1" aria-hidden="true" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => setMore(1)}
                            className="flex flex-row items-center text-red-600 text-xs mt-2 font-medium">
                            Show less{' '}
                            <ChevronUpIcon className="h-5 w-5 shrink-0 pl-1" aria-hidden="true" />
                          </button>
                        ))}
                    </div>

                    <div className="mx-4 lg:mx-2">
                      <h1>
                        Comment
                        {data.numOfComments > 1 ? 's' : ''}
                      </h1>
                      <TextareaAutosize
                        onChange={(e) => setComment(e.target.value)}
                        value={comment}
                        id="comment"
                        name="comment"
                        className="mt-4 mb-2 block w-full bg-transparent border-0 border-b p-0 pb-2 text-white placeholder:text-gray-400 focus:border-white focus:ring-0 text-xs sm:leading-6"
                        aria-label="Add your comment..."
                        placeholder="Add your comment..."
                      />
                      {posting && <span className="text-xs text-red-600">Posting comment...</span>}
                      <button
                        type="button"
                        onClick={() =>
                          postComment(comment, user.fname, user.lname, user.profile_pic === "http://d3c5pcohbexzc4.cloudfront.net/profile/avatar.png" ? '/images/avatar.png' : user.profile_pic, Date.now())
                        }
                        className="text-xs mt-4 flex flex-row items-center transition bg-red-700 hover:bg-red-800 rounded-md py-2 px-4">
                        Comment
                      </button>

                      <div className="mt-4 space-y-2">
                        {comments.map((item) => (
                          <div key={item.id}>
                            <div className="flex flex-row items-center">
                              <LazyLoadImage
                                alt="avatar"
                                placeholderSrc="https://ceflix.org/images/avatar.png"
                                className="rounded-full w-10 h-10 object-cover object-center mr-2"
                                src={item.profile_pic}
                              />
                              <div className="">
                                <div className="flex flex-row font-medium items-center text-xs">
                                  <p className="text-red-700 mr-1">
                                    {item.fname} {item.lname}
                                  </p>
                                  <p className="text-gray-300">{timeSince(item.com_time)} </p>
                                </div>
                                <p className="text-white text-sm my-1">{item.comment}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className={`${!theatre ? 'lg:col-span-2 lg:rounded-md pt-4' : 'hidden'}`}>
                    <SliderAside />
                    <div className="grid grid-cols-1 gap-4 lg:mt-0 p-4 content-start lg:p-0">
                      {upnext
                        .filter((item) => item.isLive === '0')
                        .map((item) => (
                          <div key={item.id} className="flex flex-row items-start upnext-block">
                            <Link
                              to={`/videos/watch/${item.id}/${item.videos_title
                                .replace(/[\s+-]/g, '-')
                                .toLowerCase()}`}
                              className="w-full video-block grid grid-cols-9 gap-x-4 lg:gap-x-2 cursor">
                              <div className="relative thumbnail aspect-video rounded-md img-hover-zoom img-hover-zoom--slowmo col-span-4 sm:col-span-3 lg:col-span-3">
                                <LazyLoadImage
                                  className="w-full h-full rounded-md object-cover aspect-video"
                                  alt={item.videos_title}
                                  src={item.thumbnail}
                                  placeholderSrc="https://ceflix.org/images/fallback.png"
                                />
                                {item.isLive !== '1' ? (
                                  <span className="absolute bottom-[2px] right-0 text-xxs px-2 py-1 mr-1 rounded-sm bg-neutral-900/80">
                                    {duration(item.duration)}
                                  </span>
                                ) : (
                                  <span className="absolute bottom-0 right-0 text-xxs px-2 py-1 m-1 rounded-sm bg-red-900/80">
                                    Live
                                  </span>
                                )}
                              </div>
                              <div className="flex flex-row items-start justify-between col-span-5 sm:col-span-6 lg:col-span-6">
                                <div className="grid grid-cols-1">
                                  <h1 className="truncate-video text-xs 3xl:text-sm font-semibold leading-tight text-white">
                                    {item.videos_title}
                                  </h1>
                                  <div className="text-neutral-300 mt-2 flex flex-col text-xxs">
                                    <p className="flex flex-row items-center">
                                      {truncate(item.channel, 20)}

                                      {data.isVerified === '1' && (
                                        <CheckBadgeIcon
                                          className="h-4 w-4 sm:h-4 sm:w-4 ml-1"
                                          aria-hidden="true"
                                        />
                                      )}
                                    </p>
                                    <span className="truncate">
                                      {abbreviateViews(item.numOfViews)} Views •{' '}
                                      {timeSince(item.uploadtime)}
                                    </span>
                                  </div>
                                </div>

                                <Menu as="div" className="text-xs relative inline-block text-left">
                                  <div>
                                    <Menu.Button className="transition video-block___menu flex items-center rounded-full text-white hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                                      <span className="sr-only">Open options</span>
                                      <EllipsisVerticalIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>
                                  </div>

                                  <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95">
                                    <Menu.Items className="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      <div className="py-1">
                                        <Menu.Item>
                                          {({ active }) => (
                                            <Link
                                              to="#"
                                              className={classNames(
                                                active
                                                  ? 'bg-gray-100 text-gray-900'
                                                  : 'text-gray-700',
                                                'block px-4 py-2'
                                              )}>
                                              Account settings
                                            </Link>
                                          )}
                                        </Menu.Item>
                                        <Menu.Item>
                                          {({ active }) => (
                                            <Link
                                              to="#"
                                              className={classNames(
                                                active
                                                  ? 'bg-gray-100 text-gray-900'
                                                  : 'text-gray-700',
                                                'block px-4 py-2'
                                              )}>
                                              Support
                                            </Link>
                                          )}
                                        </Menu.Item>
                                        <Menu.Item>
                                          {({ active }) => (
                                            <Link
                                              to="#"
                                              className={classNames(
                                                active
                                                  ? 'bg-gray-100 text-gray-900'
                                                  : 'text-gray-700',
                                                'block px-4 py-2'
                                              )}>
                                              License
                                            </Link>
                                          )}
                                        </Menu.Item>
                                        <form method="POST" action="#">
                                          <Menu.Item>
                                            {({ active }) => (
                                              <button
                                                type="submit"
                                                className={classNames(
                                                  active
                                                    ? 'bg-gray-100 text-gray-900'
                                                    : 'text-gray-700',
                                                  'block w-full px-4 py-2 text-left'
                                                )}>
                                                Sign out
                                              </button>
                                            )}
                                          </Menu.Item>
                                        </form>
                                      </div>
                                    </Menu.Items>
                                  </Transition>
                                </Menu>
                              </div>
                            </Link>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {theatre && (
              <div className="lg:col-span-2 lg:rounded-md pt-4 lg:pt-0">
                <SliderAside />

                {live ? (
                  <div className="grid grid-cols-1 gap-4 lg:mt-0 p-4 content-start lg:p-0">
                    {upnext
                      .filter((item) => item.isLive === '0')
                      .map((item) => (
                        <div key={item.id} className="flex flex-row items-start upnext-block">
                          <a
                            href={`/videos/watch/${item.id}/${item.videos_title
                              .replace(/[\s+-]/g, '-')
                              .toLowerCase()}`}
                            className="w-full video-block grid grid-cols-9 gap-x-4 lg:gap-x-2 cursor">
                            <div className="relative thumbnail aspect-video rounded-md img-hover-zoom img-hover-zoom--slowmo col-span-4 sm:col-span-3 lg:col-span-3">
                              <LazyLoadImage
                                className="w-full h-full rounded-md object-cover aspect-video"
                                alt={item.videos_title}
                                src={item.thumbnail}
                                placeholderSrc="https://ceflix.org/images/fallback.png"
                              />
                              {item.isLive !== '1' ? (
                                <span className="absolute bottom-[2px] right-0 text-xxs px-2 py-1 mr-1 rounded-sm bg-neutral-900/80">
                                  {duration(item.duration)}
                                </span>
                              ) : (
                                <span className="absolute bottom-0 right-0 text-xxs px-2 py-1 m-1 rounded-sm bg-red-900/80">
                                  Live
                                </span>
                              )}
                            </div>
                            <div className="flex flex-row items-start justify-between col-span-5 sm:col-span-6 lg:col-span-6">
                              <div className="grid grid-cols-1">
                                <h1 className="truncate-video text-xs 3xl:text-sm font-semibold leading-tight text-white">
                                  {item.videos_title}
                                </h1>
                                <div className="text-neutral-300 mt-2 flex flex-col text-xxs">
                                  <p className="flex flex-row items-center">
                                    {truncate(item.channel, 20)}

                                    {data.isVerified === '1' && (
                                      <CheckBadgeIcon
                                        className="h-4 w-4 sm:h-4 sm:w-4 ml-1"
                                        aria-hidden="true"
                                      />
                                    )}
                                  </p>
                                  <span className="truncate">
                                    {abbreviateViews(item.numOfViews)} Views •{' '}
                                    {timeSince(item.uploadtime)}
                                  </span>
                                </div>
                              </div>

                              <Menu as="div" className="text-xs relative inline-block text-left">
                                <div>
                                  <Menu.Button className="transition video-block___menu flex items-center rounded-full text-white hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                                    <span className="sr-only">Open options</span>
                                    <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                                  </Menu.Button>
                                </div>

                                <Transition
                                  as={Fragment}
                                  enter="transition ease-out duration-100"
                                  enterFrom="transform opacity-0 scale-95"
                                  enterTo="transform opacity-100 scale-100"
                                  leave="transition ease-in duration-75"
                                  leaveFrom="transform opacity-100 scale-100"
                                  leaveTo="transform opacity-0 scale-95">
                                  <Menu.Items className="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg focus:outline-none">
                                    <div className="py-1">
                                      <Menu.Item>
                                        {({ active }) => (
                                          <Link
                                            to="#"
                                            className={classNames(
                                              active
                                                ? 'bg-gray-100 text-gray-900'
                                                : 'text-gray-700',
                                              'block px-4 py-2'
                                            )}>
                                            Add to Playlist
                                          </Link>
                                        )}
                                      </Menu.Item>
                                    </div>
                                  </Menu.Items>
                                </Transition>
                              </Menu>
                            </div>
                          </a>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="grid grid-cols-1 gap-4 lg:mt-0 p-4 content-start lg:p-0">
                    {upnext
                      .filter((item) => item.isLive === '0')
                      .map((item) => (
                        <div key={item.id} className="flex flex-row items-start upnext-block">
                          <Link
                            to={`/videos/watch/${item.id}/${item.videos_title
                              .replace(/[\s+-]/g, '-')
                              .toLowerCase()}`}
                            className="w-full video-block grid grid-cols-9 gap-x-4 lg:gap-x-2 cursor">
                            <div className="relative thumbnail aspect-video rounded-md img-hover-zoom img-hover-zoom--slowmo col-span-4 sm:col-span-3 lg:col-span-3">
                              <LazyLoadImage
                                className="w-full h-full rounded-md object-cover aspect-video"
                                alt={item.videos_title}
                                src={item.thumbnail}
                                placeholderSrc="https://ceflix.org/images/fallback.png"
                              />
                              {item.isLive !== '1' ? (
                                <span className="absolute bottom-[2px] right-0 text-xxs px-2 py-1 mr-1 rounded-sm bg-neutral-900/80">
                                  {duration(item.duration)}
                                </span>
                              ) : (
                                <span className="absolute bottom-0 right-0 text-xxs px-2 py-1 m-1 rounded-sm bg-red-900/80">
                                  Live
                                </span>
                              )}
                            </div>
                            <div className="flex flex-row items-start justify-between col-span-5 sm:col-span-6 lg:col-span-6">
                              <div className="grid grid-cols-1">
                                <h1 className="truncate-video text-xs 3xl:text-sm font-semibold leading-tight text-white">
                                  {item.videos_title}
                                </h1>
                                <div className="text-neutral-300 mt-2 flex flex-col text-xxs">
                                  <p className="flex flex-row items-center">
                                    {truncate(item.channel, 20)}

                                    {data.isVerified === '1' && (
                                      <CheckBadgeIcon
                                        className="h-4 w-4 sm:h-4 sm:w-4 ml-1"
                                        aria-hidden="true"
                                      />
                                    )}
                                  </p>
                                  <span className="truncate">
                                    {abbreviateViews(item.numOfViews)} Views •{' '}
                                    {timeSince(item.uploadtime)}
                                  </span>
                                </div>
                              </div>

                              <Menu as="div" className="text-xs relative inline-block text-left">
                                <div>
                                  <Menu.Button className="transition video-block___menu flex items-center rounded-full text-white hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                                    <span className="sr-only">Open options</span>
                                    <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                                  </Menu.Button>
                                </div>

                                <Transition
                                  as={Fragment}
                                  enter="transition ease-out duration-100"
                                  enterFrom="transform opacity-0 scale-95"
                                  enterTo="transform opacity-100 scale-100"
                                  leave="transition ease-in duration-75"
                                  leaveFrom="transform opacity-100 scale-100"
                                  leaveTo="transform opacity-0 scale-95">
                                  <Menu.Items className="absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg focus:outline-none">
                                    <div className="py-1">
                                      <Menu.Item>
                                        {({ active }) => (
                                          <Link
                                            to="#"
                                            className={classNames(
                                              active
                                                ? 'bg-gray-100 text-gray-900'
                                                : 'text-gray-700',
                                              'block px-4 py-2'
                                            )}>
                                            Add to Playlist
                                          </Link>
                                        )}
                                      </Menu.Item>
                                    </div>
                                  </Menu.Items>
                                </Transition>
                              </Menu>
                            </div>
                          </Link>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
          </div>
          </>
        ) : (
          <Loading />
        )
      ) : (
        <div className="centered-axis-xy text-white">Video not found.</div>
      )}
    </>
  );
}
